import { FC, PropsWithChildren, useMemo } from 'react';

import { useCMSGameCovers } from '../../../hooks';
import { GameV1 } from '@/api/games';
import { getGameCover } from '@/helpers/cdn';
import { TCardMode } from '@/modules/game/types';
import { useCommonStore } from '@/store';

import {
  ScGameCardContainer,
  ScGameCardProvider,
  ScGameCardTitle,
} from './styled';

interface IGameCardWrapperProps extends PropsWithChildren {
  game: GameV1;
  mode: TCardMode;
  withoutBottom?: boolean;
  onPlayClick?: () => void;
}

export const GameCardWrapper: FC<IGameCardWrapperProps> = ({
  children,
  game,
  mode,
  withoutBottom,
  onPlayClick,
}) => {
  const { id, title, provider } = game;
  const { covers } = useCMSGameCovers();

  const providers = useCommonStore.use.providers();

  const url = useMemo(() => {
    return covers?.[id]?.cover?.url || getGameCover(id);
  }, [covers, id]);

  const providerTitle = useMemo(() => {
    if (!providers.length) return provider;
    return providers.find(({ id }) => id === provider)?.title || provider;
  }, [providers, provider]);

  return (
    <ScGameCardContainer url={url} mode={mode}>
      {children}
      {!withoutBottom && (
        <div className="bottom">
          <ScGameCardTitle
            href={`/game/${game.fullPath}`}
            onClick={onPlayClick}
          >
            {title}
          </ScGameCardTitle>
          <ScGameCardProvider href={`/games/all/${provider}#gamesSection`}>
            {providerTitle}
          </ScGameCardProvider>
        </div>
      )}
    </ScGameCardContainer>
  );
};
